<ng-container *ngFor="let item of templates$ | async; trackBy:templateTrackBy;">
    <ng-container *ngIf="item.type === 'menu'">
        <aza-rws-popup-menu
            [templateData]="item.templateData"
            [templateRef]="item.templateRef"
            [triggerHost]="item.triggerHost"
        ></aza-rws-popup-menu>
    </ng-container>
</ng-container>
